export enum IntegrationsOrderingEnum {
  Name = 'Name',
  Created = 'Created',
}
